// Routes
const routes = [
  {
    path: '/login',
    component: () => import('@/components/Login.vue'),
  },
  {
    path: '/logout',
    component: () => import('@/components/Logout.vue'),
  },
  {
    path: '/',
    component: () => import('@/components/Dash.vue'),
    children: [
      {
        path: '/pending',
        alias: '',
        component: () => import('@/components/views/Tasks/Pending.vue'),
        name: 'Pending',
        meta: {
          name: 'Pending',
          description: 'Pending Approval Tasks',
          requiresAuth: true,
        },
      },
      {
        path: '/generatePTEN',
        alias: '',
        component: () => import('@/components/views/Merchants/GeneratePTEN.vue'),
        name: 'generate',
        meta: {
          name: 'Generate PTEN',
          description: 'Generate PTEN',
          requiresAuth: true,
        },
      },
      {
        path: '/generateulangPTEN',
        alias: '',
        component: () => import('@/components/views/Merchants/GenerateulangPTEN.vue'),
        name: 'generate',
        meta: {
          name: 'Generate ulang PTEN',
          description: 'Generate ulang PTEN',
          requiresAuth: true,
         },
      },
      {
        path: '/update',
        alias: '',
        component: () => import('@/components/views/Merchants/Update.vue'),
        name: 'update',
        meta: {
          name: 'update',
          description: 'Update NMID',
          requiresAuth: true,
        },
      },
      {
        path: '/update/:jparam',
        component: () => import('@/components/views/Merchants/Update.vue'),
        name: 'update',
        meta: {
          name: 'update',
          description: 'Update NMID',
          requiresAuth: true,
        },
      },
      {
        path: '/download',
        alias: '',
        component: () => import('@/components/views/Tasks/Download.vue'),
        name: 'download',
        meta: {
          name: 'download',
          description: 'Download',
          requiresAuth: true,
        },
      },
      {
        path: 'audit',
        alias: '',
        component: () => import('@/components/views/AuditTrails.vue'),
        name: 'Audit Trails',
        meta: {
          name: 'Audit Trails',
          description: 'Audit Trails',
          requiresAuth: true,
        },
      },
      {
        path: 'audit/:start/:end',
        alias: '',
        component: () => import('@/components/views/AuditTrails.vue'),
        name: 'ululu',
        meta: {
          name: 'Audit Trails',
          description: 'Audit Trails',
          requiresAuth: true,
        },
      },
      {
        path: 'groups',
        component: () => import('@/components/views/Groups/GroupBase.vue'),
        name: 'Groups',
        meta: {
          name: 'Group Management',
          description: 'List of groups',
          requiresAuth: true,
        },
      },
      {
        path: 'groups/create',
        component: () => import('@/components/views/Groups/GroupCreate.vue'),
        name: 'GroupsCreate',
        meta: {
          name: 'Group Management',
          description: 'Create group',
          requiresAuth: true,
        },
      },
      {
        path: 'groups/edit/:id',
        component: () => import('@/components/views/Groups/GroupEdit.vue'),
        name: 'GroupsEdit',
        meta: {
          name: 'Group Management',
          description: 'Edit group',
          requiresAuth: true,
        },
      },
      {
        path: 'groups/detail/:id',
        component: () => import('@/components/views/Groups/GroupDetail.vue'),
        name: 'GroupsDetail',
        meta: {
          name: 'Group Management',
          description: 'View group detail',
          requiresAuth: true,
        },
      },
      {
        path: 'customers',
        component: () => import('@/components/views/Customers/CustomerBase.vue'),
        name: 'Customers',
        meta: {
          name: 'Customer Management',
          description: 'List of customers',
          requiresAuth: true,
        },
      },
      /*{
        path: 'customers/detail/:id',
        component: CustomerDetailView,
        name: 'CustomersDetail',
        meta: {
          name: 'Customer Management',
          description: 'View customer detail',
          requiresAuth: true,
        },
      },*/
      {
        path: 'customers/admin',
        component: () => import('@/components/views/Customers/CustomerBlock.vue'),
        name: 'CustomersBlock',
        meta: {
          name: 'Customer Management',
          description: 'Block/Unblock/Reset PIN',
          requiresAuth: true,
        },
      },
      {
        path: 'customers/upgrade',
        component: () => import('@/components/views/Customers/CustomerUpgrade.vue'),
        name: 'CustomersUpgrade',
        meta: {
          name: 'Customer Management',
          description: 'Upgrade Customer Type',
          requiresAuth: true,
        },
      },
/* close     {
        path: 'merchantrequests',
        component: MerchantRequests,
        name: 'MerchantRequests',
        meta: {
          name: 'Merchant Request List',
          description: 'List of merchant Create Request',
          requiresAuth: true,
        },
      },
      {
        path: 'merchantrequests/detail/:id',
        component: MerchantRequestsDetail,
        name: 'MerchantRequestsDetail',
        meta: {
          name: 'Merchant Request List Detail',
          description: 'Detail of merchant Create Request',
          requiresAuth: true,
        },
      },*/
      // {
      //   path: 'merchants/bulkregishistory',
      //   component: () => import('@/components/views/Merchants/MerchantBulkRegisHistory.vue'),
      //   name: 'Merchants',
      //   meta: {
      //     name: 'Merchant Management',
      //     description: 'Merchant Bulk Registration History',
      //     requiresAuth: true,
      //   },
      // },
      // {
      //   path: 'merchants/bulkregishistory/:jparam',
      //   component: () => import('@/components/views/Merchants/MerchantBulkRegisHistory.vue'),
      //   name: 'Merchants',
      //   meta: {
      //     name: 'Merchant Management',
      //     description: 'Merchant Bulk Registration History',
      //     requiresAuth: true,
      //   },
      // },
      // {
      //   path: 'merchants/bulkregishistory/detail/:jparam',
      //   component: () => import('@/components/views/Merchants/MerchantBulkRegisHistoryDetail.vue'),
      //   name: 'Merchants',
      //   meta: {
      //     name: 'Merchant Management',
      //     description: 'Merchant Bulk Registration History Detail',
      //     requiresAuth: true,
      //   },
      // },
      {
        path: 'merchants/regismerchonline',
        component: () => import('@/components/views/Merchants/MerchantRegistOnline.vue'),
        name: 'MerchantsRegisOnline',
        meta: {
          name: 'Merchant Management',
          description: 'Merchant Registration Online',
          requiresAuth: true,
        },
      },
      {
        path: 'merchants/regismerchonline/:jparam',
        component: () => import('@/components/views/Merchants/MerchantRegistOnline.vue'),
        name: 'MerchantsRegisOnline',
        meta: {
          name: 'Merchant Management',
          description: 'Merchant Registration Online',
          requiresAuth: true,
        },
      },
      {
        path: 'merchants/regismerchonline/detail/:id',
        component: () => import('@/components/views/Merchants/MerchantRegistOnlineDetail.vue'),
        name: 'MerchantsRegisOnlineDetail',
        meta: {
          name: 'Merchant Management',
          description: 'Merchant Registration Online detail',
          requiresAuth: true,
        },
      },
      {
        path: 'merchants/regisdraft',
        component: () => import('@/components/views/Merchants/MerchantRegisDraft.vue'),
        name: 'Merchants Regis',
        meta: {
          name: 'Merchant Management',
          description: 'Merchant Registration Draft',
          requiresAuth: true,
        },
      },
      {
        path: 'merchants/regisdraft/:jparam',
        component: () => import('@/components/views/Merchants/MerchantRegisDraft.vue'),
        name: 'Merchants Regis',
        meta: {
          name: 'Merchant Management',
          description: 'Merchant Registration Draft',
          requiresAuth: true,
        },
      },
      {
        path: 'merchants/regisdraft/detail/:jparam',
        component: () => import('@/components/views/Merchants/MerchantRegisDraftDetail.vue'),
        name: 'Merchants Regis Detail',
        meta: {
          name: 'Merchant Management',
          description: 'Merchant Registration Draft Detail',
          requiresAuth: true,
        },
      },
      {
        path: 'qrgenerators/uploaddata',
        component: () => import('@/components/views/QRGenerator/QRGenerator.vue'),
        name: 'QRGeneratorsUploadData',
        meta: {
          name: 'QR Generator',
          description: 'Upload Data',
          requiresAuth: true,
        },
      },
      {
        path: 'qrgenerators/downloaddata',
        component: () => import('@/components/views/QRGenerator/QRGeneratorDownloadData.vue'),
        name: 'QRGeneratorsDownloadData',
        meta: {
          name: 'QR Generator',
          description: 'Download Data',
          requiresAuth: true,
        },
      },
      {
        path: 'qrgenerators/detail/:id',
        component: () => import('@/components/views/QRGenerator/QRGeneratorDetail.vue'),
        name: 'QRGeneratorsDetail',
        meta: {
          name: 'QR Generator',
          description: 'View QR Generator detail',
          requiresAuth: true,
        },
      },
      {
        path: 'merchants/create',
        component: () => import('@/components/views/Merchants/MerchantCreate.vue'),
        name: 'MerchantsCreate',
        meta: {
          name: 'Merchant Management',
          description: 'Register merchant',
          requiresAuth: true,
        },
      },
      // {
      //   path: 'merchants/create/registconfirm/:id',
      //   component: () => import('@/components/views/Merchants/MerchantConfirmRegist.vue'),
      //   name: 'MerchantsRegistConfirmBulk',
      //   meta: {
      //     name: 'Merchant Management',
      //     description: 'Konfirmasi Register Merchant',
      //     requiresAuth: true,
      //   },
      // },
      {
        path: 'merchants/regisdraft/edit/:id',
        component: () => import('@/components/views/Merchants/MerchantRegisDraftEdit.vue'),
        name: 'Merchants Regis Edit',
        meta: {
          name: 'Merchant Management',
          description: 'Merchant Registration Draft Edit Data',
          requiresAuth: true,
        },
      },
      {
        path: 'merchants/edit/:id',
        component: () => import('@/components/views/Merchants/MerchantEdit.vue'),
        name: 'MerchantsEdit',
        meta: {
          name: 'Merchant Management',
          description: 'Edit merchant',
          requiresAuth: true,
        },
      },
      {
        path: 'merchants/detail/:id',
        component: () => import('@/components/views/Merchants/MerchantDetail.vue'),
        name: 'MerchantsDetail',
        meta: {
          name: 'Merchant Management',
          description: 'View merchant detail',
          requiresAuth: true,
        },
      },
      {
        path: 'merchants',
        component: () => import('@/components/views/Merchants/MerchantBase.vue'),
        name: 'Merchants',
        meta: {
          name: 'Merchant Management',
          description: 'List of merchant',
          requiresAuth: true,
        },
      },
      {
        path: 'merchants/:jparam',
        component: () => import('@/components/views/Merchants/MerchantBase.vue'),
        name: 'Merchants',
        meta: {
          name: 'Merchant Management',
          description: 'List of merchant',
          requiresAuth: true,
        },
      },
      {
        path: 'categories',
        component: () => import('@/components/views/Categories/CategoryBase.vue'),
        name: 'Categories',
        meta: {
          name: 'Content Management',
          description: 'Type & Category',
          requiresAuth: true,
        },
      },
      {
        //   path: 'categories',
        //   component: CategoryTypeBase,
        //   name: 'Categories',
        //   meta: {name: 'Content Management', description: 'Type & Category', requiresAuth: true}
        // }, { 
        path: 'categories/types',
        component: () => import('@/components/views/Categories/CategoryType.vue'),
        name: 'CategoriesType',
        meta: {
          name: 'Content Management',
          description: 'List of type',
          requiresAuth: true,
        },
      },
      {
        path: 'categories/types/create',
        component: () => import('@/components/views/Categories/CategoryTypeCreate.vue'),
        name: 'CategoriesTypeCreate',
        meta: {
          name: 'Content Management',
          description: 'Create type',
          requiresAuth: true,
        },
      },
      {
        path: 'categories/types/edit/:id',
        component: () => import('@/components/views/Categories/CategoryTypeEdit.vue'),
        name: 'CategoriesTypeEdit',
        meta: {
          name: 'Content Management',
          description: 'Edit type',
          requiresAuth: true,
        },
      },
      {
        path: 'categories/detail/:id',
        component: () => import('@/components/views/Categories/CategoryDetail.vue'),
        name: 'CategoriesDetail',
        meta: {
          name: 'Content Management',
          description: 'View category detail',
          requiresAuth: true,
        },
      },
      {
        path: 'categories/create',
        component: () => import('@/components/views/Categories/CategoryCreate.vue'),
        name: 'CategoriesCreate',
        meta: {
          name: 'Content Management',
          description: 'Create category',
          requiresAuth: true,
        },
      },
      {
        path: 'categories/edit/:id',
        component: () => import('@/components/views/Categories/CategoryEdit.vue'),
        name: 'CategoriesEdit',
        meta: {
          name: 'Content Management',
          description: 'Edit category',
          requiresAuth: true,
        },
      },
      {
        path: 'contents',
        component: () => import('@/components/views/Contents/ContentBase.vue'),
        name: 'Contents',
        meta: {
          name: 'Content Management',
          description: 'List of content',
          requiresAuth: true,
        },
      },
      {
        path: 'contents/create',
        component: () => import('@/components/views/Contents/ContentCreate.vue'),
        name: 'ContentsCreate',
        meta: {
          name: 'Content Management',
          description: 'Create content',
          requiresAuth: true,
        },
      },
      {
        path: 'contents/edit/:id',
        component: () => import('@/components/views/Contents/ContentEdit.vue'),
        name: 'ContentsEdit',
        meta: {
          name: 'Content Management',
          description: 'Edit content',
          requiresAuth: true,
        },
      },
      {
        path: 'contents/detail/:id',
        component: () => import('@/components/views/Contents/ContentDetail.vue'),
        name: 'ContentsDetail',
        meta: {
          name: 'Content Management',
          description: 'View content detail',
          requiresAuth: true,
        },
      },
      {
        path: 'notifications',
        component: () => import('@/components/views/Notifications/NotificationBase.vue'),
        name: 'Notifications',
        meta: {
          name: 'Notification Management',
          description: 'List of notification',
          requiresAuth: true,
        },
      },
      {
        path: 'notifications/create',
        component: () => import('@/components/views/Notifications/NotificationCreate.vue'),
        name: 'NotificationsCreate',
        meta: {
          name: 'Notification Management',
          description: 'Create notification',
          requiresAuth: true,
        },
      },
      {
        path: 'notifications/edit/:id',
        component: () => import('@/components/views/Notifications/NotificationEdit.vue'),
        name: 'NotificationsEdit',
        meta: {
          name: 'Notification Management',
          description: 'Edit notification',
          requiresAuth: true,
        },
      },
      {
        path: 'notifications/detail/:nid',
        component: () => import('@/components/views/Notifications/NotificationDetail.vue'),
        name: 'NotificationsDetail',
        meta: {
          name: 'Notification Management',
          description: 'View notification detail',
          requiresAuth: true,
        },
      },
      {
        path: 'reports/confirm/:payload',
        component: () => import('@/components/views/Reports/ConfirmManualCredit.vue'),
        name: 'ConfirmManualCredit',
        meta: {
          name: 'Confirmation',
          description: 'Confirmation',
          requiresAuth: true,
        },
      },
      {
        path: 'reports/customer',
        component: () => import('@/components/views/Reports/ReportCustomer.vue'),
        name: 'ReportsCustomer',
        meta: {
          name: 'Report',
          description: 'Customer Transaction Report',
          requiresAuth: true,
        },
      },
      {
        path: 'reports/customer/:start/:end/:uid/:memberno/:groupcode/:uref',
        component: () => import('@/components/views/Reports/ReportCustomer.vue'),
        name: 'ReportsCustomer',
        meta: {
          name: 'Report',
          description: 'Customer Transaction Report',
          requiresAuth: true,
        },
      },
      {
        path: 'reports/merchant',
        component: () => import('@/components/views/Reports/ReportMerchant.vue'),
        name: 'ReportsMerchant',
        meta: {
          name: 'Report',
          description: 'Merchant Transaction Report',
          requiresAuth: true,
        },
      },
      {
        path: 'reports/merchant/:jparam',
        component: () => import('@/components/views/Reports/ReportMerchant.vue'),
        name: 'ReportsMerchant',
        meta: {
          name: 'Report',
          description: 'Merchant Transaction Report',
          requiresAuth: true,
        },
      },
      {
        path: 'reports/settlement',
        component: () => import('@/components/views/Reports/ReportSettlement.vue'),
        name: 'Reportssettlement',
        meta: {
          name: 'Report',
          description: 'Settlement Report',
          requiresAuth: true,
        },
      },
      {
        path: 'reports/settlement/:date',
        component: () => import('@/components/views/Reports/ReportSettlementTableView.vue'),
        name: 'ReportSettlementTableView',
        meta: {
          name: 'Report',
          description: 'Settlement Report',
          requiresAuth: true,
        },
      },
      {
        path: 'reports/qrissuer',
        component: () => import('@/components/views/Reports/ReportQRIssuer.vue'),
        name: 'ReportQRIssuer',
        meta: {
          name: 'Report',
          description: 'QR Transaction as Issuer Report',
          requiresAuth: true,
        },
      },
      {
        path: 'reports/qrissuer/:date',
        component: () => import('@/components/views/Reports/ReportQRIssuer.vue'),
        name: 'ReportQRIssuer',
        meta: {
          name: 'Report',
          description: 'QR Transaction as Issuer Report',
          requiresAuth: true,
        },
      },
      {
        path: 'reports/qracquirer',
        component: () => import('@/components/views/Reports/ReportQRAcquirer.vue'),
        name: 'ReportQRAcquirer',
        meta: {
          name: 'Report',
          description: 'QR Transaction as Acquirer Report',
          requiresAuth: true,
        },
      },
      {
        path: 'reports/qracquirer/:date',
        component: () => import('@/components/views/Reports/ReportQRAcquirer.vue'),
        name: 'ReportQRAcquirer',
        meta: {
          name: 'Report',
          description: 'QR Transaction as Acquirer Report',
          requiresAuth: true,
        },
      },
      {
        path: 'reports/mancrissuer',
        component: () => import('@/components/views/Reports/ManualCreditAsIssuer.vue'),
        name: 'ManualCreditIssuer',
        meta: {
          name: 'Report',
          description: 'Manual Credit (Dispute as Issuer)',
          requiresAuth: true,
        },
      },
      {
        path: 'reports/mancracquirer',
        component: () => import('@/components/views/Reports/ManualCreditAsAcquirer.vue'),
        name: 'ManualCreditAcquirer',
        meta: {
          name: 'Report',
          description: 'Manual Credit (Dispute as Acquirer)',
          requiresAuth: true,
        },
      },
      {
        path: 'reports/settlement/detail/:id/:date',
        component: () => import('@/components/views/Reports/ReportSettlementDetail.vue'),
        name: 'ReportssettlementDetail',
        meta: {
          name: 'Report',
          description: 'settlement Detail Report',
          requiresAuth: true,
        },
      },
      {
        path: 'roles',
        component: () => import('@/components/views/Roles/RoleBase.vue'),
        name: 'Roles',
        meta: {
          name: 'Role Management',
          description: 'List of roles',
          requiresAuth: true,
        },
      },
      {
        path: 'roles/create',
        component: () => import('@/components/views/Roles/RoleCreate.vue'),
        name: 'RolesCreate',
        meta: {
          name: 'Role Management',
          description: 'Create role',
          requiresAuth: true,
        },
      },
      {
        path: 'roles/edit/:id',
        component: () => import('@/components/views/Roles/RoleEdit.vue'),
        name: 'RolesEdit',
        meta: {
          name: 'Role Management',
          description: 'Edit role',
          requiresAuth: true,
        },
      },
      {
        path: 'roles/detail/:id',
        component: () => import('@/components/views/Roles/RoleDetail.vue'),
        name: 'RolesDetail',
        meta: {
          name: 'Role Management',
          description: 'View role detail',
          requiresAuth: true,
        },
      },
      {
        path: 'users',
        component: () => import('@/components/views/Users/UserBase.vue'),
        name: 'Users',
        meta: {
          name: 'User Management',
          description: 'List of users',
          requiresAuth: true,
        },
      },
      {
        path: 'users/create',
        component: () => import('@/components/views/Users/UserCreate.vue'),
        name: 'UsersCreate',
        meta: {
          name: 'User Management',
          description: 'Create user',
          requiresAuth: true,
        },
      },
      {
        path: 'users/edit/:id',
        component: () => import('@/components/views/Users/UserEdit.vue'),
        name: 'UsersEdit',
        meta: {
          name: 'User Management',
          description: 'Edit user',
          requiresAuth: true,
        },
      },
      {
        path: 'users/detail/:id',
        component: () => import('@/components/views/Users/UserDetail.vue'),
        name: 'UsersDetail',
        meta: {
          name: 'User Management',
          description: 'View user detail',
          requiresAuth: true,
        },
      },
      {
        path: 'users/block',
        component: () => import('@/components/views/Users/UserBlock.vue'),
        name: 'UsersBlock',
        meta: {
          name: 'User Management',
          description: 'Delete User',
          requiresAuth: true,
        },
      },
      {
        path: 'questions',
        component: () => import('@/components/views/Questions/QuestionBase.vue'),
        name: 'Questions',
        meta: {
          name: 'Security Question Management',
          description: 'List of security questions',
          requiresAuth: true,
        },
      },
      {
        path: 'questions/create',
        component: () => import('@/components/views/Questions/QuestionCreate.vue'),
        name: 'QuestionsCreate',
        meta: {
          name: 'Security Question Management',
          description: 'Create security question',
          requiresAuth: true,
        },
      },
      {
        path: 'questions/edit/:id',
        component: () => import('@/components/views/Questions/QuestionEdit.vue'),
        name: 'QuestionsEdit',
        meta: {
          name: 'Security Question Management',
          description: 'Edit security question',
          requiresAuth: true,
        },
      },
      {
        path: 'questions/detail/:id',
        component: () => import('@/components/views/Questions/QuestionDetail.vue'),
        name: 'QuestionsDetail',
        meta: {
          name: 'Security Question Management',
          description: 'View security question detail',
          requiresAuth: true,
        },
      },
      {
        path: 'resetpwd',
        component: () => import('@/components/views/Password.vue'),
        name: 'ResetPassword',
        meta: {
          name: 'Reset Password',
          description: 'Reset own password',
          requiresAuth: true,
        },
      },
      {
        path: 'mdr',
        component: () => import('@/components/views/Mdr/MdrBase.vue'),
        name: 'Mdr',
        meta: {
          name: 'MDR',
          description: 'MDR',
          requiresAuth: true,
        },
      },
      {
        path: 'mdr/create',
        component: () => import('@/components/views/Mdr/MdrCreate.vue'),
        name: 'MdrCreate',
        meta: {
          name: 'MDR Create',
          description: 'Create MDR',
          requiresAuth: true,
        },
      },
      {
        path: 'mdr/edit/:id',
        component: () => import('@/components/views/Mdr/MdrEdit.vue'),
        name: 'MdrEdit',
        meta: {
          name: 'MDR Edit',
          description: 'Edit MDR',
          requiresAuth: true,
        },
      },
    /*
      {
        path: 'mdr/detail/create',
        component: () => import('@/components/views/Mdr/MdrDetailCreate.vue'),
        name: 'MdrDetailCreate',
        meta: {
          name: 'Create Detail MDR',
          description: 'Create Detail MDR',
          requiresAuth: true,
        },
      },
*/
      {
        path: 'mdr/detail/:id',
        component: () => import('@/components/views/Mdr/MdrDetail.vue'),
        name: 'MdrDetail',
        meta: {
          name: 'Detail MDR',
          description: 'Detail MDR',
          requiresAuth: true,
        },
      },
      {
        path: 'fee/transaction',
        component: () =>
          import('@/components/views/FeeTransaction/FeeTransactionBase.vue'),
        name: 'FeeTransaction',
        meta: {
          name: 'Fee Transaction',
          description: 'Fee Transaction',
          requiresAuth: true,
        },
      },
      {
        path: 'sukses/:pload',
        component: () => import('@/components/views/Sukses.vue'),
        name: 'sukses',
        meta: {
          name: 'Sukses',
          description: 'Action Sukses',
          requiresAuth: true,
        },
      },
      {
        path: 'sysmanage',
        component: () =>
          import(
            '@/components/views/SystemManagement/SystemManagementBase.vue'
          ),
        name: 'sysmanage',
        meta: {
          name: 'System Management',
          description: 'System Management',
          requiresAuth: true,
        },
      },
      {
        path: 'edc',
        component: () => import('@/components/views/EDC/EDCBase.vue'),
        name: 'EDC',
        meta: {
          name: 'Monitoring EDC',
          description: 'Monitoring EDC Status',
          requiresAuth: true,
        },
      },
      {
        path: 'edc/:jparam',
        component: () => import('@/components/views/EDC/EDCBase.vue'),
        name: 'EDC',
        meta: {
          name: 'Monitoring EDC',
          description: 'Monitoring EDC Status',
          requiresAuth: true,
        },
      },
      /*      //MdrCatCode     
            {
              path: 'MdrCatCode/create',
              component: () => import('@/components/views/MdrCatCode/MdrCatCodeCreate.vue'),
              name: 'MdrCatCodeCreate',
              meta: {
                name: 'MdrCatCode Create',
                description: 'Create MdrCatCode',
                requiresAuth: true,
              },
            },*/
    ],
  },
  {
    // not found handler
    path: '*',
    component: () => import('@/components/404.vue'),
  },
]

export default routes


// WEBPACK FOOTER //
// ./src/routes.js